import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import bell from "../assets/images/bell.svg";
import image_prf from "../assets/images/image_prf.svg";
import add from "../assets/images/add.svg";
import add_blue from "../assets/images/add_blue.svg";
import chat_square_quote from "../assets/images/chat/chat-square-quote.svg";
import down_arrow from "../assets/images/down_arrow.svg";
import { AppContext } from "../context/AppContext";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import profile from "../assets/images/ProfileIcon/ProfileDrop.svg";
import ProfileActive from "../assets/images/ProfileIcon/ProfileActive.svg";
import AchimentDrop from "../assets/images/ProfileIcon/AcgimentDrop.svg";
import AchivementActive from "../assets/images/ProfileIcon/AchivementActive.svg";
import EarningDrop from "../assets/images/ProfileIcon/EarningDrop.svg";
import EarningActive from "../assets/images/ProfileIcon/EarninigActive.svg";
import DiaryDrop from "../assets/images/ProfileIcon/DiaryDrop.svg";
import DiaryActive from "../assets/images/ProfileIcon/DiaryActive.svg";
import DocuentActive from "../assets/images/ProfileIcon/DocuentActive.svg";
import DocumentDrop from "../assets/images/ProfileIcon/DocumentDrop.svg";
import dropup from "../assets/images/dropUp.svg";
import downarrowlist from "../assets/images/downarrowlist.svg";
import ApiConfig, { PROFILR_iMG_PATH } from "../api/ApiConfig";
import ic_online from "../assets/images/chat/ic_online.svg";
import ic_away from "../assets/images/chat/ic_away.svg";
import ic_busy from "../assets/images/chat/ic_busy.svg";
import ic_gray from "../assets/images/chat/ic_gray.svg";
import {
  PostCallWithErrorResponse,
  postWithAuthCallWithErrorResponse,
} from "../api/ApiServices";
import { notifySuccess } from "../toaster/notify";
import { ToastMsg } from "../pages/TostMsg";
import { Accordion, Modal } from "react-bootstrap";
import close from "../assets/images/close.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { Select } from "antd";

const Header = ({ setLoggedIn }) => {
  const navigate = useNavigate();
  const {
    Dark,
    setDark,
    socket,
    userData,
    unreadCount,
    headerProfile,
    notifications,
    setCurrentSChannel,
    setActiveChat,
    projects,
    teams,
    storesList,
    recentChats,
    pinnedChats,
    selectedStoreID,
    setSocket,
    setUserData,
    // setLoggedIn,
    setOpenSessionLogoutModal,
    openSessionLogoutModal,
    domains,
    setSelectedStoreID,
    setSelectedRestName,
    setSelectedDomain,
    setDomainName,
    selectedRestID,
    setSelectedRestID,
    permissions,
  } = useContext(AppContext);

  console.log("selectedRestID ==>", selectedRestID);

  const [onGoingCall, setonGoingCall] = useState([]);
  const [statusUser, setStatusUser] = useState({});
  const currentRoute = useLocation().pathname;

  const showDropdownRoutes = [
    "storemanage",
    "basemenu",
    "menuonoff",
    "onlineorderactivity",
    "managestore",
    "stock",
    "storeconfig",
    "printList",
    "zamzam-sales-report",
    "zamzam-day-wise-report",
    "categories-report",
    "order-summary-report",
    "sales-vs-material-report",
  ];

  const shouldShowDropdown = showDropdownRoutes.some((route) =>
    currentRoute.includes(route),
  );
  const [logoutModalShow, setLogoutModalShow] = useState(false);

  useEffect(() => {
    document.body.className = Dark;
  }, [Dark]);

  const darkTheme = () => {
    if (Dark === "darkMode") {
      setDark("lightMode");
    } else {
      setDark("darkMode");
    }
  };

  useEffect(() => {
    socket &&
      socket.on("ongoing-call", (data) => {
        setonGoingCall(data);
      });
  }, [socket]);

  const setStatus = (status) => {
    let body = JSON.stringify({ user_status: status });
    PostCallWithErrorResponse(ApiConfig.SET_STATUS, body).then((res) => {
      if (res.json.success) {
        notifySuccess(res.json.message);
        console.log(setStatus, "setstatus");
      }
    });
  };
  // Profile Image change on hover
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);
  const [isHovered5, setIsHovered5] = useState(false);

  const onMouseEnter = () => {
    setIsHovered(true);
  };
  const onMouseLeave = () => {
    setIsHovered(false);
  };

  const onMouseEnter1 = () => {
    setIsHovered1(true);
  };
  const onMouseLeave1 = () => {
    setIsHovered1(false);
  };

  const onMouseEnter2 = () => {
    setIsHovered2(true);
  };
  const onMouseLeave2 = () => {
    setIsHovered2(false);
  };
  const onMouseEnter3 = () => {
    setIsHovered3(true);
  };
  const onMouseLeave3 = () => {
    setIsHovered3(false);
  };
  const onMouseEnter4 = () => {
    setIsHovered4(true);
  };
  const onMouseLeave4 = () => {
    setIsHovered4(false);
  };
  const onMouseEnter5 = () => {
    setIsHovered5(true);
  };
  const onMouseLeave5 = () => {
    setIsHovered5(false);
  };

  useEffect(() => {
    const employeeId = localStorage.getItem("EmpId");
    console.log("employeeId--->", employeeId);
    const body = {
      EmployeeId: parseInt(employeeId),
    };
    PostCallWithErrorResponse(ApiConfig.USERSTATUS, JSON.stringify(body))
      .then((res) => {
        console.log(res);
        if (res.json && res.json?.Success === true) {
          // ToastMsg("success", res.json.Message);
          setStatusUser(res.json?.Data[0]);
          // navigate("/")
        } else {
          ToastMsg("error", res.json.Message);
        }
      })
      .catch((err) => console.log(err));

    console.log("Profile path--->", headerProfile);

    // console.log("user img--->",ApiConfig.BASE_URL_FOR_IMAGES + headerProfile?.img)
  }, []);

  const userStatus = (icon) => {
    switch (icon) {
      case "online":
        return ic_online;
      case "offline":
        return ic_gray;
      case "Away":
        return ic_away;
      case "Busy":
        return ic_busy;
      default:
        return null; // or you can return a default icon if desired
    }
  };

  const userLogout = () => {
    PostCallWithErrorResponse(
      ApiConfig.LOGOUT,
      JSON.stringify({ IsWebLogin: true }),
    ).then((res) => {
      if (res.json.Success === true) {
        ToastMsg("success", res.json.Message);
      } else {
        ToastMsg("error", res.json.Message);
      }
    });
  };

  const logout = (e) => {
    userLogout();
    localStorage.clear();
    socket && socket.disconnect();
    setSocket(null);
    setUserData({});
    setLoggedIn(false);
    setLogoutModalShow(false);
    setOpenSessionLogoutModal(false);
  };

  // Ensure storesList is properly formatted
  useEffect(() => {}, [storesList]);
  const formattedStores = storesList?.length
    ? storesList.map((store) => ({
        value: store.value,
        label: store.label,
        id: store.id, // assuming store.value is your restID
      }))
    : [];
  // useEffect(() => {
  //   const storedRestID = localStorage.getItem("selectedStoreRestID");

  //   if (storedRestID && formattedStores.length > 0) {
  //     const matchedStore = formattedStores.find(store => store.id === storedRestID);
  //     if (matchedStore) {
  //       setSelectedRestID(matchedStore);       // for Select component
  //       // setSelectedRestID(matchedStore.id);   // just restID
  //     }
  //   }
  // }, [formattedStores]); // wait for formattedStores to load

  // useEffect(() => {
  //   // Retrieve selected store ID from localStorage on component mount
  //   const storedStoreID = localStorage.getItem("selectedStoreID");
  //   if (storedStoreID) {
  //     setSelectedStoreID(JSON.parse(storedStoreID)); // Parse if stored as an object
  //   }
  // }, []);

  //   const handleChange = (selectedOption) => {
  //   console.log("Selected Option:", selectedOption.id);

  //   setSelectedStoreID(selectedOption);                   // For Select component
  //   setSelectedRestID(selectedOption.id);               // Save just restID
  //   localStorage.setItem("selectedStoreRestID", selectedOption.id); // Persist only restID
  // };

  // const handleChange = (selectedOption) => {

  //   // Find the full object from storesList using restID
  //   const matchedStore = formattedStores.find(store => store.value === selectedOption);
  //   setSelectedStoreID(selectedOption); // numeric ID from original list

  //   if (matchedStore) {
  //     // setSelectedStoreID(selectedOption); // numeric ID from original list
  //     setSelectedRestID(matchedStore.id); // restID from original list
  //     setSelectedRestName(matchedStore.label); // restID from original list

  //     localStorage.setItem("selectedStoreRestID", matchedStore.id);
  //     localStorage.setItem("selectedStoreId", selectedOption);
  //   }

  //   // If needed for Select component itself
  //   // setSelectedOption(selectedOption);
  // };

  const handleChange = (selectedOption) => {
    const matchedStore = formattedStores.find(
      (store) => store.value === selectedOption,
    );

    setSelectedStoreID(selectedOption);

    if (matchedStore) {
      setSelectedRestID(matchedStore.id);
      setSelectedRestName(matchedStore.label);

      localStorage.setItem("selectedStoreRestID", matchedStore.id);
      localStorage.setItem("selectedStoreId", selectedOption);
    }
  };
  return (
    <main className="cx-header">
      <div className={"cx-header-wrapper"}>
        {/* <div className="mb-4" style={{ marginTop: "30px", marginInlineEnd: "-15px", marginRight: "5px" }}  >
          <Select
            options={[
              {
                label: 'Downtown Store'
              }
            ]}
            // value={selectedStoreID}

            // onChange={handleChange}
            className=""
            placeholder="Choose a store..."
            style={{
              width: "200px"
            }}

          />

        </div> */}
        {shouldShowDropdown &&
          permissions &&
          permissions["View Inventory Management"] &&
          permissions["Inventory Reports"] && (
            <div
              className="mb-4"
              style={{
                marginTop: "30px",
                marginInlineEnd: "-15px",
                marginRight: "55px",
              }}
            >
              <Select
                options={formattedStores}
                value={selectedStoreID}
                onChange={handleChange}
                placeholder="Choose a store..."
                className=""
                style={{
                  width: "200px",
                }}
              />
            </div>
          )}

        {permissions && permissions["Employee Wallet"] != true ? (
          <header
            className="d-flex align-items-center"
            id="mainHeader"
            style={{ height: "50px" }}
          >
            {currentRoute === "/SalesGoods" ||
            currentRoute === "/incomeNonGst" ||
            currentRoute === "/incomeGst" ||
            currentRoute === "/SalesHome" ||
            currentRoute === "/SalesServices" ||
            currentRoute === "/salesReport" ? (
              <div className="form-check form-switch d-inline">
                <input
                  onClick={darkTheme}
                  className="form-check-input switch-greenBtnHeader"
                  type="checkbox"
                  role="switch"
                />
              </div>
            ) : (
              <div className="form-check form-switch d-inline">
                <input
                  onClick={darkTheme}
                  className="form-check-input switch-blueBtnHeader"
                  type="checkbox"
                  role="switch"
                />
              </div>
            )}

            {permissions && permissions["Select ChatBot Domain"] && (
              <Dropdown id="customDropdown" className="me-2">
                <Dropdown.Toggle
                  id="customDropdownToggle"
                  style={{ scale: "1.6", marginInlineEnd: "-15px" }}
                  title="Domains"
                  className="btn-light"
                >
                  <FontAwesomeIcon
                    icon={faGlobe}
                    className="earth-icon icon"
                    width={20}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  id="customDropdownMenu"
                  style={
                    domains.length > 10 && {
                      height: "500px",
                      overflowY: "scroll",
                    }
                  }
                >
                  {domains?.map((item, index) => (
                    <Dropdown.Item
                      href=""
                      key={item?.id}
                      onClick={() => {
                        setSelectedDomain(item?.id);
                        setDomainName(item?.domain);
                      }}
                    >
                      {item?.domain}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            )}
            {/* <button
            onClick={darkTheme}
            className=" me-3"
            style={{ border: "none", background: "transparent" }}
          >
            {Dark === "lightMode" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="rgba(17, 17, 17, 0.5)"
                className="bi bi-moon-fill"
                viewBox="0 0 16 16"
              >
                <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#cccccc"
                className="bi bi-moon-fill"
                viewBox="0 0 16 16"
              >
                <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z" />
              </svg>
            )}
          </button> */}
            <Link to="#" className="btn-header">
              {/*             
              <button
                className={
                  currentRoute === "/purchaseGoods" ||
                  currentRoute === "/PurchaseServices" ||
                  currentRoute === "/expenseGst" ||
                  currentRoute === "/expenseNonGst" ||
                  currentRoute === "/purchaseReport"
                    ? "blueBtnHeader"
                    : "greenBtnHeader"
                }
              >
                Join Call
              </button> */}
            </Link>
            <Link to="#" className="bell">
              <Dropdown
                className="ProfileHeader status-img-shadow"
                data-toggle="tooltip"
                data-placement="top"
                title="Read Notification"
              >
                <Dropdown.Toggle variant="">
                  <img src={bell} className="bellyIcon" alt="" />
                  {unreadCount > 0 && (
                    <span class="badgeHeader">{unreadCount}</span>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu
                  // show=
                  aria-expanded={
                    Array.isArray(notifications) && notifications?.length > 0
                      ? true
                      : false
                  }
                >
                  {notifications &&
                    notifications.map((notification, index) => {
                      return (
                        <Dropdown.Item
                          href="#"
                          onMouseEnter={onMouseEnter1}
                          onMouseLeave={onMouseLeave1}
                          key={"notification" + index}
                          onClick={() => {
                            setCurrentSChannel(notification.Team_Channel_Id);

                            const isTeamsMessage =
                              teams &&
                              teams.length > 0 &&
                              teams.some((item) => {
                                return item?.subchannel.some(
                                  (subItem) =>
                                    subItem?.Team_Channel_Id ==
                                    notification?.Team_Channel_Id,
                                );
                              });

                            const isProjectMessage =
                              projects &&
                              projects.length > 0 &&
                              projects.some((item) => {
                                return item?.subchannel.some(
                                  (subItem) =>
                                    subItem?.Team_Channel_Id ==
                                    notification?.Team_Channel_Id,
                                );
                              });

                            if (isProjectMessage) {
                              let project =
                                Array.isArray(projects) &&
                                projects.find(
                                  (proj) =>
                                    proj?.channel_name ==
                                    notification?.channel_name,
                                );

                              let channel =
                                project &&
                                project?.subchannel &&
                                project?.subchannel.filter(
                                  (channel) =>
                                    channel.Team_Channel_Id ==
                                    notification.Team_Channel_Id,
                                )[0];

                              setActiveChat({
                                pin: false,
                                ...channel,
                                project:
                                  project && project.channel_name
                                    ? project.channel_name
                                    : "",
                                channel_name:
                                  channel && channel.Team_Channel_Name
                                    ? channel.Team_Channel_Name
                                    : "",
                                channel_id: channel && channel.Team_Channel_Id,
                              });
                              navigate("/projects");
                            } else if (isTeamsMessage) {
                              let team =
                                Array.isArray(teams) &&
                                teams.find(
                                  (proj) =>
                                    proj?.channel_name ==
                                    notification?.channel_name,
                                );

                              let channel =
                                team &&
                                team?.subchannel &&
                                team?.subchannel.filter(
                                  (channel) =>
                                    channel.Team_Channel_Id ==
                                    notification.Team_Channel_Id,
                                )[0];

                              setActiveChat({
                                pin: false,
                                ...channel,
                                project:
                                  team && team.channel_name
                                    ? team.channel_name
                                    : "",
                                channel_name:
                                  channel && channel.Team_Channel_Name
                                    ? channel.Team_Channel_Name
                                    : "",
                                channel_id: channel && channel.Team_Channel_Id,
                              });
                              navigate("/teams");
                            } else {
                              console.log("heade pinnedChats,", pinnedChats);
                              console.log("heade recChats,", recentChats);
                              console.log(
                                "notification.Team_Channel_Id,",
                                notification,
                              );
                              let activechat =
                                recentChats.length > 0 &&
                                recentChats.filter((chat) =>
                                  chat.Team_Channel_Id ==
                                  notification.Team_Channel_Id
                                    ? {
                                        pin: false,
                                        ...chat,
                                      }
                                    : chat,
                                );
                              console.log("activechat[0],", activechat[0]);

                              setActiveChat(
                                activechat[0]
                                  ? activechat[0]
                                  : pinnedChats &&
                                      pinnedChats.length > 0 &&
                                      pinnedChats.filter(
                                        (chat) =>
                                          chat.Team_Channel_Id ==
                                          notification.Team_Channel_Id,
                                      )[0],
                              );
                              navigate("/chat");
                            }
                          }}
                        >
                          <div className="d-flex">
                            <label
                              style={{
                                fontSize: "10px",
                                fontStyle: "italic",
                                marginBottom: "5px",
                              }}
                            >
                              <img src={bell} alt="" />{" "}
                              {notification.notification_type == "message" &&
                                "Message From "}
                              <span className="activeColorBlue">
                                {notification.FirstName +
                                  " " +
                                  notification.LastName +
                                  " "}
                              </span>
                              {notification.notification_type == "mention" &&
                                "Mentioned you "}
                              {"in "}{" "}
                              {notification.channel_name == "private"
                                ? "Multichat"
                                : notification.channel_name +
                                  "-" +
                                  notification.Team_Channel_Name}
                            </label>
                          </div>
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              </Dropdown>
            </Link>

            <Link to="#" className="btn-header">
              {/* <button
                className={
                  currentRoute === "/purchaseGoods" ||
                  currentRoute === "/PurchaseServices" ||
                  currentRoute === "/expenseGst" ||
                  currentRoute === "/expenseNonGst" ||
                  currentRoute === "/purchaseReport"
                    ? "blueBtnHeader"
                    : "greenBtnHeader"
                }
              >
                Admin
              </button> */}
            </Link>
            <Dropdown
              className="ProfileHeader status-img-shadow"
              data-toggle="tooltip"
              data-placement="top"
              title="Set Staus"
            >
              <Dropdown.Toggle variant="" className="backgroundWhite">
                <img src={chat_square_quote} alt="" className="set-status" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  href="#"
                  onMouseEnter={onMouseEnter1}
                  onMouseLeave={onMouseLeave1}
                  onClick={() => setStatus("online")}
                >
                  <img src={ic_online} />
                  <label
                    className="activeColorBlue"
                    style={{ fontSize: "10px" }}
                  >
                    Online{" "}
                  </label>
                </Dropdown.Item>
                <Dropdown.Item
                  href="#"
                  onMouseEnter={onMouseEnter1}
                  onMouseLeave={onMouseLeave1}
                  onClick={() => setStatus("busy")}
                >
                  <img src={ic_busy} />
                  <label
                    className="activeColorBlue"
                    style={{ fontSize: "10px" }}
                  >
                    Busy{" "}
                  </label>
                </Dropdown.Item>
                {/* <Dropdown.Item
                href="#"
                onMouseEnter={onMouseEnter1}
                onMouseLeave={onMouseLeave1}
              >
                <img src={ic_busy} />
                <label className="activeColorBlue" style={{ fontSize: "10px" }}>Do Not Desturb </label>
              </Dropdown.Item> */}
                <Dropdown.Item
                  href="#"
                  onMouseEnter={onMouseEnter1}
                  onMouseLeave={onMouseLeave1}
                  onClick={() => setStatus("away")}
                >
                  <img src={ic_away} />
                  <label
                    className="activeColorBlue"
                    style={{ fontSize: "10px" }}
                  >
                    Away{" "}
                  </label>
                </Dropdown.Item>
                <Dropdown.Item
                  href="#"
                  onMouseEnter={onMouseEnter1}
                  onMouseLeave={onMouseLeave1}
                  onClick={() => setStatus("offline")}
                >
                  <img src={ic_gray} />
                  <label
                    className="activeColorBlue"
                    style={{ fontSize: "10px" }}
                  >
                    Offline{" "}
                  </label>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Link to="#" className="profile-header">
              <img
                src={
                  // !headerProfile?.PhotoPath
                  //   ? image_prf
                  //   : headerProfile?.PhotoPath.length
                  //     ? ApiConfig.BASE_URL_FOR_IMAGES + headerProfile?.PhotoPath
                  //     : headerProfile?.PhotoPath &&
                  //     URL.createObjectURL(headerProfile?.PhotoPath)
                  ApiConfig.BASE_URL_FOR_IMAGES + headerProfile
                }
                onError={(e) => (e.target.src = image_prf)}
                alt=""
                className="pic"
              />
              <span className="add-green">
                {currentRoute === "/purchaseGoods" ||
                currentRoute === "/PurchaseServices" ||
                currentRoute === "/expenseGst" ||
                currentRoute === "/expenseNonGst" ||
                currentRoute === "/purchaseReport" ? (
                  <img src={add_blue} alt="" />
                ) : (
                  <img src={userStatus(statusUser?.UserStatus)} alt="" />
                )}
              </span>
            </Link>

            <Dropdown className="ProfileHeader">
              <Dropdown.Toggle variant="" id="dropdown-basic">
                <img src={down_arrow} alt="" className="header-down-arrow" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {/* {permissions && permissions.includes("My Profile") && (
               
              )} */}
                <Dropdown.Item
                  href="#/action-1"
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                >
                  {currentRoute == "/Profile" ? (
                    //permissions&&permissions['View My Profile']&&
                    <Link
                      to={"/Profile/" + userData.EmpId}
                      className={
                        currentRoute == "/Profile" ? "activeColorBlue" : ""
                      }
                    >
                      {isHovered ? (
                        <svg
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.0635 8.84863C15.0635 9.9095 14.642 10.9269 13.8919 11.6771C13.1418 12.4272 12.1243 12.8486 11.0635 12.8486C10.0026 12.8486 8.98519 12.4272 8.23505 11.6771C7.4849 10.9269 7.06348 9.9095 7.06348 8.84863C7.06348 7.78777 7.4849 6.77035 8.23505 6.02021C8.98519 5.27006 10.0026 4.84863 11.0635 4.84863C12.1243 4.84863 13.1418 5.27006 13.8919 6.02021C14.642 6.77035 15.0635 7.78777 15.0635 8.84863ZM13.0635 8.84863C13.0635 9.37907 12.8528 9.88777 12.4777 10.2628C12.1026 10.6379 11.5939 10.8486 11.0635 10.8486C10.533 10.8486 10.0243 10.6379 9.64926 10.2628C9.27419 9.88777 9.06348 9.37907 9.06348 8.84863C9.06348 8.3182 9.27419 7.80949 9.64926 7.43442C10.0243 7.05935 10.533 6.84863 11.0635 6.84863C11.5939 6.84863 12.1026 7.05935 12.4777 7.43442C12.8528 7.80949 13.0635 8.3182 13.0635 8.84863Z"
                            fill="#53B7E8"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0635 0.848633C4.98848 0.848633 0.0634766 5.77363 0.0634766 11.8486C0.0634766 17.9236 4.98848 22.8486 11.0635 22.8486C17.1385 22.8486 22.0635 17.9236 22.0635 11.8486C22.0635 5.77363 17.1385 0.848633 11.0635 0.848633ZM2.06348 11.8486C2.06348 13.9386 2.77648 15.8626 3.97148 17.3906C4.81071 16.2885 5.89338 15.3954 7.13491 14.7809C8.37644 14.1665 9.74322 13.8474 11.1285 13.8486C12.4958 13.8473 13.8454 14.1582 15.0744 14.7574C16.3034 15.3567 17.3794 16.2286 18.2205 17.3066C19.0869 16.1702 19.6703 14.8438 19.9224 13.4372C20.1744 12.0306 20.0879 10.5842 19.67 9.21762C19.252 7.85107 18.5147 6.60368 17.519 5.57867C16.5232 4.55366 15.2977 3.78049 13.9439 3.32314C12.59 2.86579 11.1467 2.7374 9.73334 2.94861C8.32 3.15981 6.97727 3.70452 5.81625 4.53769C4.65522 5.37085 3.70929 6.4685 3.05671 7.73983C2.40412 9.01115 2.06366 10.4196 2.06348 11.8486ZM11.0635 20.8486C8.99743 20.8517 6.99374 20.141 5.39148 18.8366C6.03641 17.9134 6.89481 17.1596 7.89367 16.6393C8.89252 16.1191 10.0023 15.8478 11.1285 15.8486C12.2406 15.8477 13.337 16.1122 14.3264 16.6201C15.3158 17.1279 16.1698 17.8645 16.8175 18.7686C15.2028 20.1153 13.1661 20.8516 11.0635 20.8486Z"
                            fill="#53B7E8"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.0635 8.84863C15.0635 9.9095 14.642 10.9269 13.8919 11.6771C13.1418 12.4272 12.1243 12.8486 11.0635 12.8486C10.0026 12.8486 8.98519 12.4272 8.23505 11.6771C7.4849 10.9269 7.06348 9.9095 7.06348 8.84863C7.06348 7.78777 7.4849 6.77035 8.23505 6.02021C8.98519 5.27006 10.0026 4.84863 11.0635 4.84863C12.1243 4.84863 13.1418 5.27006 13.8919 6.02021C14.642 6.77035 15.0635 7.78777 15.0635 8.84863ZM13.0635 8.84863C13.0635 9.37907 12.8528 9.88777 12.4777 10.2628C12.1026 10.6379 11.5939 10.8486 11.0635 10.8486C10.533 10.8486 10.0243 10.6379 9.64926 10.2628C9.27419 9.88777 9.06348 9.37907 9.06348 8.84863C9.06348 8.3182 9.27419 7.80949 9.64926 7.43442C10.0243 7.05935 10.533 6.84863 11.0635 6.84863C11.5939 6.84863 12.1026 7.05935 12.4777 7.43442C12.8528 7.80949 13.0635 8.3182 13.0635 8.84863Z"
                            fill="#53B7E8"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0635 0.848633C4.98848 0.848633 0.0634766 5.77363 0.0634766 11.8486C0.0634766 17.9236 4.98848 22.8486 11.0635 22.8486C17.1385 22.8486 22.0635 17.9236 22.0635 11.8486C22.0635 5.77363 17.1385 0.848633 11.0635 0.848633ZM2.06348 11.8486C2.06348 13.9386 2.77648 15.8626 3.97148 17.3906C4.81071 16.2885 5.89338 15.3954 7.13491 14.7809C8.37644 14.1665 9.74322 13.8474 11.1285 13.8486C12.4958 13.8473 13.8454 14.1582 15.0744 14.7574C16.3034 15.3567 17.3794 16.2286 18.2205 17.3066C19.0869 16.1702 19.6703 14.8438 19.9224 13.4372C20.1744 12.0306 20.0879 10.5842 19.67 9.21762C19.252 7.85107 18.5147 6.60368 17.519 5.57867C16.5232 4.55366 15.2977 3.78049 13.9439 3.32314C12.59 2.86579 11.1467 2.7374 9.73334 2.94861C8.32 3.15981 6.97727 3.70452 5.81625 4.53769C4.65522 5.37085 3.70929 6.4685 3.05671 7.73983C2.40412 9.01115 2.06366 10.4196 2.06348 11.8486ZM11.0635 20.8486C8.99743 20.8517 6.99374 20.141 5.39148 18.8366C6.03641 17.9134 6.89481 17.1596 7.89367 16.6393C8.89252 16.1191 10.0023 15.8478 11.1285 15.8486C12.2406 15.8477 13.337 16.1122 14.3264 16.6201C15.3158 17.1279 16.1698 17.8645 16.8175 18.7686C15.2028 20.1153 13.1661 20.8516 11.0635 20.8486Z"
                            fill="#53B7E8"
                          />
                        </svg>
                      )}
                      {/* <span className={isHovered ? "activeColorBlue" : ""}>
                      My Profile
                    </span> */}

                      <span className="activeColorBlue">My Profile</span>
                    </Link>
                  ) : (
                    <Link
                      to={"/Profile/" + userData.EmpId}
                      className={isHovered ? "activeColorBlue" : ""}
                    >
                      {isHovered ? (
                        <svg
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.0635 8.84863C15.0635 9.9095 14.642 10.9269 13.8919 11.6771C13.1418 12.4272 12.1243 12.8486 11.0635 12.8486C10.0026 12.8486 8.98519 12.4272 8.23505 11.6771C7.4849 10.9269 7.06348 9.9095 7.06348 8.84863C7.06348 7.78777 7.4849 6.77035 8.23505 6.02021C8.98519 5.27006 10.0026 4.84863 11.0635 4.84863C12.1243 4.84863 13.1418 5.27006 13.8919 6.02021C14.642 6.77035 15.0635 7.78777 15.0635 8.84863ZM13.0635 8.84863C13.0635 9.37907 12.8528 9.88777 12.4777 10.2628C12.1026 10.6379 11.5939 10.8486 11.0635 10.8486C10.533 10.8486 10.0243 10.6379 9.64926 10.2628C9.27419 9.88777 9.06348 9.37907 9.06348 8.84863C9.06348 8.3182 9.27419 7.80949 9.64926 7.43442C10.0243 7.05935 10.533 6.84863 11.0635 6.84863C11.5939 6.84863 12.1026 7.05935 12.4777 7.43442C12.8528 7.80949 13.0635 8.3182 13.0635 8.84863Z"
                            fill="#53B7E8"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0635 0.848633C4.98848 0.848633 0.0634766 5.77363 0.0634766 11.8486C0.0634766 17.9236 4.98848 22.8486 11.0635 22.8486C17.1385 22.8486 22.0635 17.9236 22.0635 11.8486C22.0635 5.77363 17.1385 0.848633 11.0635 0.848633ZM2.06348 11.8486C2.06348 13.9386 2.77648 15.8626 3.97148 17.3906C4.81071 16.2885 5.89338 15.3954 7.13491 14.7809C8.37644 14.1665 9.74322 13.8474 11.1285 13.8486C12.4958 13.8473 13.8454 14.1582 15.0744 14.7574C16.3034 15.3567 17.3794 16.2286 18.2205 17.3066C19.0869 16.1702 19.6703 14.8438 19.9224 13.4372C20.1744 12.0306 20.0879 10.5842 19.67 9.21762C19.252 7.85107 18.5147 6.60368 17.519 5.57867C16.5232 4.55366 15.2977 3.78049 13.9439 3.32314C12.59 2.86579 11.1467 2.7374 9.73334 2.94861C8.32 3.15981 6.97727 3.70452 5.81625 4.53769C4.65522 5.37085 3.70929 6.4685 3.05671 7.73983C2.40412 9.01115 2.06366 10.4196 2.06348 11.8486ZM11.0635 20.8486C8.99743 20.8517 6.99374 20.141 5.39148 18.8366C6.03641 17.9134 6.89481 17.1596 7.89367 16.6393C8.89252 16.1191 10.0023 15.8478 11.1285 15.8486C12.2406 15.8477 13.337 16.1122 14.3264 16.6201C15.3158 17.1279 16.1698 17.8645 16.8175 18.7686C15.2028 20.1153 13.1661 20.8516 11.0635 20.8486Z"
                            fill="#53B7E8"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.0635 8.84863C15.0635 9.9095 14.642 10.9269 13.8919 11.6771C13.1418 12.4272 12.1243 12.8486 11.0635 12.8486C10.0026 12.8486 8.98519 12.4272 8.23505 11.6771C7.4849 10.9269 7.06348 9.9095 7.06348 8.84863C7.06348 7.78777 7.4849 6.77035 8.23505 6.02021C8.98519 5.27006 10.0026 4.84863 11.0635 4.84863C12.1243 4.84863 13.1418 5.27006 13.8919 6.02021C14.642 6.77035 15.0635 7.78777 15.0635 8.84863ZM13.0635 8.84863C13.0635 9.37907 12.8528 9.88777 12.4777 10.2628C12.1026 10.6379 11.5939 10.8486 11.0635 10.8486C10.533 10.8486 10.0243 10.6379 9.64926 10.2628C9.27419 9.88777 9.06348 9.37907 9.06348 8.84863C9.06348 8.3182 9.27419 7.80949 9.64926 7.43442C10.0243 7.05935 10.533 6.84863 11.0635 6.84863C11.5939 6.84863 12.1026 7.05935 12.4777 7.43442C12.8528 7.80949 13.0635 8.3182 13.0635 8.84863Z"
                            fill="rgba(17, 17, 17, 0.5)"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0635 0.848633C4.98848 0.848633 0.0634766 5.77363 0.0634766 11.8486C0.0634766 17.9236 4.98848 22.8486 11.0635 22.8486C17.1385 22.8486 22.0635 17.9236 22.0635 11.8486C22.0635 5.77363 17.1385 0.848633 11.0635 0.848633ZM2.06348 11.8486C2.06348 13.9386 2.77648 15.8626 3.97148 17.3906C4.81071 16.2885 5.89338 15.3954 7.13491 14.7809C8.37644 14.1665 9.74322 13.8474 11.1285 13.8486C12.4958 13.8473 13.8454 14.1582 15.0744 14.7574C16.3034 15.3567 17.3794 16.2286 18.2205 17.3066C19.0869 16.1702 19.6703 14.8438 19.9224 13.4372C20.1744 12.0306 20.0879 10.5842 19.67 9.21762C19.252 7.85107 18.5147 6.60368 17.519 5.57867C16.5232 4.55366 15.2977 3.78049 13.9439 3.32314C12.59 2.86579 11.1467 2.7374 9.73334 2.94861C8.32 3.15981 6.97727 3.70452 5.81625 4.53769C4.65522 5.37085 3.70929 6.4685 3.05671 7.73983C2.40412 9.01115 2.06366 10.4196 2.06348 11.8486ZM11.0635 20.8486C8.99743 20.8517 6.99374 20.141 5.39148 18.8366C6.03641 17.9134 6.89481 17.1596 7.89367 16.6393C8.89252 16.1191 10.0023 15.8478 11.1285 15.8486C12.2406 15.8477 13.337 16.1122 14.3264 16.6201C15.3158 17.1279 16.1698 17.8645 16.8175 18.7686C15.2028 20.1153 13.1661 20.8516 11.0635 20.8486Z"
                            fill="rgba(17, 17, 17, 0.5)"
                          />
                        </svg>
                      )}
                      <span className={isHovered ? "activeColorBlue" : ""}>
                        My Profile
                      </span>
                      {/* <span className={isHovered ? "activeColorBlue" : ""}>
                      My Profile
                    </span> */}
                      {/* {currentRoute === "/Profile" ? (
                      <span className="activeColorBlue">My Profile</span>
                    ) : (
                      <span className="hovercolor">My Profile</span>
                    )} */}
                    </Link>
                  )}
                </Dropdown.Item>
                {/* {permissions && permissions["View My Diary"] && (
                  <Dropdown.Item
                    href="#/action-2"
                    onMouseEnter={onMouseEnter1}
                    onMouseLeave={onMouseLeave1}
                  >
                    {currentRoute == "/achivements" ? (
                      <Link
                        to="/achivements"
                        className={
                          currentRoute == "/achivements"
                            ? "activeColorBlue"
                            : ""
                        }
                      >
                        {isHovered1 ? (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.7578 19.8486H13.7578V16.8486L12.7578 15.8486L11.7578 16.8486V19.8486H10.7578C9.65781 19.8486 8.75781 20.7486 8.75781 21.8486V22.8486H16.7578V21.8486C16.7578 21.3182 16.5471 20.8095 16.172 20.4344C15.797 20.0593 15.2882 19.8486 14.7578 19.8486Z"
                              fill="#53B7E8"
                            />
                            <path
                              d="M12.7578 2.18652L14.4417 7.3689H19.8907L15.4823 10.5718L17.1662 15.7542L12.7578 12.5513L8.34942 15.7542L10.0333 10.5718L5.62489 7.3689H11.074L12.7578 2.18652Z"
                              fill="#53B7E8"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.7578 19.8486H13.7578V16.8486L12.7578 15.8486L11.7578 16.8486V19.8486H10.7578C9.65781 19.8486 8.75781 20.7486 8.75781 21.8486V22.8486H16.7578V21.8486C16.7578 21.3182 16.5471 20.8095 16.172 20.4344C15.797 20.0593 15.2882 19.8486 14.7578 19.8486Z"
                              fill="#53B7E8"
                            />
                            <path
                              d="M12.7578 2.18652L14.4417 7.3689H19.8907L15.4823 10.5718L17.1662 15.7542L12.7578 12.5513L8.34942 15.7542L10.0333 10.5718L5.62489 7.3689H11.074L12.7578 2.18652Z"
                              fill="#53B7E8"
                            />
                          </svg>
                        )}
                        <span className={isHovered ? "activeColorBlue" : ""}>
                      My Profile
                    </span>
                        <span className="activeColorBlue">My Achievements</span>
                      </Link>
                    ) : (
                      <Link
                        to="/achivements"
                        className={isHovered1 ? "activeColorBlue" : ""}
                      >
                        {isHovered1 ? (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.7578 19.8486H13.7578V16.8486L12.7578 15.8486L11.7578 16.8486V19.8486H10.7578C9.65781 19.8486 8.75781 20.7486 8.75781 21.8486V22.8486H16.7578V21.8486C16.7578 21.3182 16.5471 20.8095 16.172 20.4344C15.797 20.0593 15.2882 19.8486 14.7578 19.8486Z"
                              fill="#53B7E8"
                            />
                            <path
                              d="M12.7578 2.18652L14.4417 7.3689H19.8907L15.4823 10.5718L17.1662 15.7542L12.7578 12.5513L8.34942 15.7542L10.0333 10.5718L5.62489 7.3689H11.074L12.7578 2.18652Z"
                              fill="#53B7E8"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.7578 19.8486H13.7578V16.8486L12.7578 15.8486L11.7578 16.8486V19.8486H10.7578C9.65781 19.8486 8.75781 20.7486 8.75781 21.8486V22.8486H16.7578V21.8486C16.7578 21.3182 16.5471 20.8095 16.172 20.4344C15.797 20.0593 15.2882 19.8486 14.7578 19.8486Z"
                              fill="rgba(17, 17, 17, 0.5)"
                            />
                            <path
                              d="M12.7578 2.18652L14.4417 7.3689H19.8907L15.4823 10.5718L17.1662 15.7542L12.7578 12.5513L8.34942 15.7542L10.0333 10.5718L5.62489 7.3689H11.074L12.7578 2.18652Z"
                              fill="rgba(17, 17, 17, 0.5)"
                            />
                          </svg>
                        )}
                        <span className={isHovered1 ? "activeColorBlue" : ""}>
                          My Achievements
                        </span>
                      </Link>
                    )}
                  </Dropdown.Item>
                )} */}
                {permissions && permissions["My Earnings"] && (
                  <Dropdown.Item
                    href="#/action-2"
                    onMouseEnter={onMouseEnter2}
                    onMouseLeave={onMouseLeave2}
                  >
                    {currentRoute == "#" ? (
                      <Link
                        to="#"
                        className={currentRoute == "#" ? "activeColorBlue" : ""}
                      >
                        {isHovered2 ? (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.8081 3.44333C14.8292 3.41679 14.8555 3.39482 14.8854 3.37876C14.9152 3.36269 14.948 3.35286 14.9818 3.34987C15.0155 3.34687 15.0496 3.35078 15.0818 3.36135C15.114 3.37191 15.1437 3.38892 15.1691 3.41133L16.0901 4.22333L13.1911 7.84833H15.1121L17.2181 5.21633L18.8701 6.67333C18.919 6.7165 18.9491 6.77704 18.9539 6.84204C18.9588 6.90705 18.938 6.97139 18.8961 7.02133L18.2061 7.84833H20.1501C20.391 7.49581 20.4946 7.06742 20.4415 6.64381C20.3885 6.2202 20.1824 5.8306 19.8621 5.54833L16.1621 2.28533C15.9837 2.12813 15.775 2.00897 15.5489 1.93512C15.3228 1.86128 15.084 1.83429 14.8472 1.85581C14.6103 1.87734 14.3803 1.94692 14.1712 2.06032C13.9621 2.17371 13.7784 2.32853 13.6311 2.51533L9.42815 7.84833H11.3381L14.8081 3.44333ZM16.7021 14.8483C16.5032 14.8483 16.3125 14.9273 16.1718 15.068C16.0312 15.2087 15.9521 15.3994 15.9521 15.5983C15.9521 15.7972 16.0312 15.988 16.1718 16.1287C16.3125 16.2693 16.5032 16.3483 16.7021 16.3483H18.7021C18.9011 16.3483 19.0918 16.2693 19.2325 16.1287C19.3731 15.988 19.4521 15.7972 19.4521 15.5983C19.4521 15.3994 19.3731 15.2087 19.2325 15.068C19.0918 14.9273 18.9011 14.8483 18.7021 14.8483H16.7021ZM4.95215 8.09833C4.95215 7.89942 5.03117 7.70865 5.17182 7.568C5.31247 7.42735 5.50324 7.34833 5.70215 7.34833H8.83015L10.0221 5.84833H5.70215C5.10541 5.84833 4.53311 6.08538 4.11116 6.50734C3.6892 6.9293 3.45215 7.50159 3.45215 8.09833V18.5983C3.45215 19.4603 3.79456 20.2869 4.40405 20.8964C5.01354 21.5059 5.84019 21.8483 6.70215 21.8483H18.7021C19.5641 21.8483 20.3908 21.5059 21.0002 20.8964C21.6097 20.2869 21.9521 19.4603 21.9521 18.5983V12.0983C21.9521 11.2364 21.6097 10.4097 21.0002 9.80023C20.3908 9.19074 19.5641 8.84833 18.7021 8.84833H5.70215C5.50324 8.84833 5.31247 8.76931 5.17182 8.62866C5.03117 8.48801 4.95215 8.29724 4.95215 8.09833ZM4.95215 18.5983V10.2203C5.18715 10.3033 5.43915 10.3483 5.70215 10.3483H18.7021C19.6681 10.3483 20.4521 11.1323 20.4521 12.0983V18.5983C20.4521 19.0625 20.2678 19.5076 19.9396 19.8358C19.6114 20.164 19.1663 20.3483 18.7021 20.3483H6.70215C6.23802 20.3483 5.7929 20.164 5.46471 19.8358C5.13652 19.5076 4.95215 19.0625 4.95215 18.5983Z"
                              fill="#53B7E8"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.8081 3.44333C14.8292 3.41679 14.8555 3.39482 14.8854 3.37876C14.9152 3.36269 14.948 3.35286 14.9818 3.34987C15.0155 3.34687 15.0496 3.35078 15.0818 3.36135C15.114 3.37191 15.1437 3.38892 15.1691 3.41133L16.0901 4.22333L13.1911 7.84833H15.1121L17.2181 5.21633L18.8701 6.67333C18.919 6.7165 18.9491 6.77704 18.9539 6.84204C18.9588 6.90705 18.938 6.97139 18.8961 7.02133L18.2061 7.84833H20.1501C20.391 7.49581 20.4946 7.06742 20.4415 6.64381C20.3885 6.2202 20.1824 5.8306 19.8621 5.54833L16.1621 2.28533C15.9837 2.12813 15.775 2.00897 15.5489 1.93512C15.3228 1.86128 15.084 1.83429 14.8472 1.85581C14.6103 1.87734 14.3803 1.94692 14.1712 2.06032C13.9621 2.17371 13.7784 2.32853 13.6311 2.51533L9.42815 7.84833H11.3381L14.8081 3.44333ZM16.7021 14.8483C16.5032 14.8483 16.3125 14.9273 16.1718 15.068C16.0312 15.2087 15.9521 15.3994 15.9521 15.5983C15.9521 15.7972 16.0312 15.988 16.1718 16.1287C16.3125 16.2693 16.5032 16.3483 16.7021 16.3483H18.7021C18.9011 16.3483 19.0918 16.2693 19.2325 16.1287C19.3731 15.988 19.4521 15.7972 19.4521 15.5983C19.4521 15.3994 19.3731 15.2087 19.2325 15.068C19.0918 14.9273 18.9011 14.8483 18.7021 14.8483H16.7021ZM4.95215 8.09833C4.95215 7.89942 5.03117 7.70865 5.17182 7.568C5.31247 7.42735 5.50324 7.34833 5.70215 7.34833H8.83015L10.0221 5.84833H5.70215C5.10541 5.84833 4.53311 6.08538 4.11116 6.50734C3.6892 6.9293 3.45215 7.50159 3.45215 8.09833V18.5983C3.45215 19.4603 3.79456 20.2869 4.40405 20.8964C5.01354 21.5059 5.84019 21.8483 6.70215 21.8483H18.7021C19.5641 21.8483 20.3908 21.5059 21.0002 20.8964C21.6097 20.2869 21.9521 19.4603 21.9521 18.5983V12.0983C21.9521 11.2364 21.6097 10.4097 21.0002 9.80023C20.3908 9.19074 19.5641 8.84833 18.7021 8.84833H5.70215C5.50324 8.84833 5.31247 8.76931 5.17182 8.62866C5.03117 8.48801 4.95215 8.29724 4.95215 8.09833ZM4.95215 18.5983V10.2203C5.18715 10.3033 5.43915 10.3483 5.70215 10.3483H18.7021C19.6681 10.3483 20.4521 11.1323 20.4521 12.0983V18.5983C20.4521 19.0625 20.2678 19.5076 19.9396 19.8358C19.6114 20.164 19.1663 20.3483 18.7021 20.3483H6.70215C6.23802 20.3483 5.7929 20.164 5.46471 19.8358C5.13652 19.5076 4.95215 19.0625 4.95215 18.5983Z"
                              fill="#53B7E8"
                            />
                          </svg>
                        )}
                        {/* <span className={isHovered ? "activeColorBlue" : ""}>
                      My Profile
                    </span> */}
                        <span className="activeColorBlue">My Earnings</span>
                      </Link>
                    ) : (
                      <Link
                        to="#"
                        className={isHovered2 ? "activeColorBlue" : ""}
                      >
                        {isHovered2 ? (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.8081 3.44333C14.8292 3.41679 14.8555 3.39482 14.8854 3.37876C14.9152 3.36269 14.948 3.35286 14.9818 3.34987C15.0155 3.34687 15.0496 3.35078 15.0818 3.36135C15.114 3.37191 15.1437 3.38892 15.1691 3.41133L16.0901 4.22333L13.1911 7.84833H15.1121L17.2181 5.21633L18.8701 6.67333C18.919 6.7165 18.9491 6.77704 18.9539 6.84204C18.9588 6.90705 18.938 6.97139 18.8961 7.02133L18.2061 7.84833H20.1501C20.391 7.49581 20.4946 7.06742 20.4415 6.64381C20.3885 6.2202 20.1824 5.8306 19.8621 5.54833L16.1621 2.28533C15.9837 2.12813 15.775 2.00897 15.5489 1.93512C15.3228 1.86128 15.084 1.83429 14.8472 1.85581C14.6103 1.87734 14.3803 1.94692 14.1712 2.06032C13.9621 2.17371 13.7784 2.32853 13.6311 2.51533L9.42815 7.84833H11.3381L14.8081 3.44333ZM16.7021 14.8483C16.5032 14.8483 16.3125 14.9273 16.1718 15.068C16.0312 15.2087 15.9521 15.3994 15.9521 15.5983C15.9521 15.7972 16.0312 15.988 16.1718 16.1287C16.3125 16.2693 16.5032 16.3483 16.7021 16.3483H18.7021C18.9011 16.3483 19.0918 16.2693 19.2325 16.1287C19.3731 15.988 19.4521 15.7972 19.4521 15.5983C19.4521 15.3994 19.3731 15.2087 19.2325 15.068C19.0918 14.9273 18.9011 14.8483 18.7021 14.8483H16.7021ZM4.95215 8.09833C4.95215 7.89942 5.03117 7.70865 5.17182 7.568C5.31247 7.42735 5.50324 7.34833 5.70215 7.34833H8.83015L10.0221 5.84833H5.70215C5.10541 5.84833 4.53311 6.08538 4.11116 6.50734C3.6892 6.9293 3.45215 7.50159 3.45215 8.09833V18.5983C3.45215 19.4603 3.79456 20.2869 4.40405 20.8964C5.01354 21.5059 5.84019 21.8483 6.70215 21.8483H18.7021C19.5641 21.8483 20.3908 21.5059 21.0002 20.8964C21.6097 20.2869 21.9521 19.4603 21.9521 18.5983V12.0983C21.9521 11.2364 21.6097 10.4097 21.0002 9.80023C20.3908 9.19074 19.5641 8.84833 18.7021 8.84833H5.70215C5.50324 8.84833 5.31247 8.76931 5.17182 8.62866C5.03117 8.48801 4.95215 8.29724 4.95215 8.09833ZM4.95215 18.5983V10.2203C5.18715 10.3033 5.43915 10.3483 5.70215 10.3483H18.7021C19.6681 10.3483 20.4521 11.1323 20.4521 12.0983V18.5983C20.4521 19.0625 20.2678 19.5076 19.9396 19.8358C19.6114 20.164 19.1663 20.3483 18.7021 20.3483H6.70215C6.23802 20.3483 5.7929 20.164 5.46471 19.8358C5.13652 19.5076 4.95215 19.0625 4.95215 18.5983Z"
                              fill="#53B7E8"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.8081 3.44333C14.8292 3.41679 14.8555 3.39482 14.8854 3.37876C14.9152 3.36269 14.948 3.35286 14.9818 3.34987C15.0155 3.34687 15.0496 3.35078 15.0818 3.36135C15.114 3.37191 15.1437 3.38892 15.1691 3.41133L16.0901 4.22333L13.1911 7.84833H15.1121L17.2181 5.21633L18.8701 6.67333C18.919 6.7165 18.9491 6.77704 18.9539 6.84204C18.9588 6.90705 18.938 6.97139 18.8961 7.02133L18.2061 7.84833H20.1501C20.391 7.49581 20.4946 7.06742 20.4415 6.64381C20.3885 6.2202 20.1824 5.8306 19.8621 5.54833L16.1621 2.28533C15.9837 2.12813 15.775 2.00897 15.5489 1.93512C15.3228 1.86128 15.084 1.83429 14.8472 1.85581C14.6103 1.87734 14.3803 1.94692 14.1712 2.06032C13.9621 2.17371 13.7784 2.32853 13.6311 2.51533L9.42815 7.84833H11.3381L14.8081 3.44333ZM16.7021 14.8483C16.5032 14.8483 16.3125 14.9273 16.1718 15.068C16.0312 15.2087 15.9521 15.3994 15.9521 15.5983C15.9521 15.7972 16.0312 15.988 16.1718 16.1287C16.3125 16.2693 16.5032 16.3483 16.7021 16.3483H18.7021C18.9011 16.3483 19.0918 16.2693 19.2325 16.1287C19.3731 15.988 19.4521 15.7972 19.4521 15.5983C19.4521 15.3994 19.3731 15.2087 19.2325 15.068C19.0918 14.9273 18.9011 14.8483 18.7021 14.8483H16.7021ZM4.95215 8.09833C4.95215 7.89942 5.03117 7.70865 5.17182 7.568C5.31247 7.42735 5.50324 7.34833 5.70215 7.34833H8.83015L10.0221 5.84833H5.70215C5.10541 5.84833 4.53311 6.08538 4.11116 6.50734C3.6892 6.9293 3.45215 7.50159 3.45215 8.09833V18.5983C3.45215 19.4603 3.79456 20.2869 4.40405 20.8964C5.01354 21.5059 5.84019 21.8483 6.70215 21.8483H18.7021C19.5641 21.8483 20.3908 21.5059 21.0002 20.8964C21.6097 20.2869 21.9521 19.4603 21.9521 18.5983V12.0983C21.9521 11.2364 21.6097 10.4097 21.0002 9.80023C20.3908 9.19074 19.5641 8.84833 18.7021 8.84833H5.70215C5.50324 8.84833 5.31247 8.76931 5.17182 8.62866C5.03117 8.48801 4.95215 8.29724 4.95215 8.09833ZM4.95215 18.5983V10.2203C5.18715 10.3033 5.43915 10.3483 5.70215 10.3483H18.7021C19.6681 10.3483 20.4521 11.1323 20.4521 12.0983V18.5983C20.4521 19.0625 20.2678 19.5076 19.9396 19.8358C19.6114 20.164 19.1663 20.3483 18.7021 20.3483H6.70215C6.23802 20.3483 5.7929 20.164 5.46471 19.8358C5.13652 19.5076 4.95215 19.0625 4.95215 18.5983Z"
                              fill="rgba(17, 17, 17, 0.5)"
                            />
                          </svg>
                        )}
                        <span className={isHovered2 ? "activeColorBlue" : ""}>
                          My Earnings
                        </span>
                      </Link>
                    )}
                  </Dropdown.Item>
                )}

                <Dropdown.Item
                  href="#/action-4"
                  onMouseEnter={onMouseEnter3}
                  onMouseLeave={onMouseLeave3}
                >
                  {currentRoute == "/mydiary" ? (
                    <Link
                      to="/mydiary"
                      className={
                        currentRoute == "/mydiary" ? "activeColorBlue" : ""
                      }
                    >
                      {isHovered3 ? (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1465 2.84863H5.14648C4.88127 2.84863 4.62691 2.95399 4.43938 3.14153C4.25184 3.32906 4.14648 3.58342 4.14648 3.84863V19.8486C4.14648 20.1138 4.25184 20.3682 4.43938 20.5557C4.62691 20.7433 4.88127 20.8486 5.14648 20.8486H6.14648V21.8486C6.14648 22.1138 6.25184 22.3682 6.43938 22.5557C6.62691 22.7433 6.88127 22.8486 7.14648 22.8486C7.4117 22.8486 7.66605 22.7433 7.85359 22.5557C8.04113 22.3682 8.14648 22.1138 8.14648 21.8486V20.8486H17.1465C17.9421 20.8486 18.7052 20.5326 19.2678 19.97C19.8304 19.4073 20.1465 18.6443 20.1465 17.8486V5.84863C20.1465 5.05298 19.8304 4.28992 19.2678 3.72731C18.7052 3.1647 17.9421 2.84863 17.1465 2.84863ZM14.1465 18.8486H6.14648V4.84863H14.1465V18.8486ZM18.1465 17.8486C18.1465 18.1138 18.0411 18.3682 17.8536 18.5557C17.6661 18.7433 17.4117 18.8486 17.1465 18.8486H16.1465V4.84863H17.1465C17.4117 4.84863 17.6661 4.95399 17.8536 5.14153C18.0411 5.32906 18.1465 5.58342 18.1465 5.84863V17.8486Z"
                            fill="#53B7E8"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1465 2.84863H5.14648C4.88127 2.84863 4.62691 2.95399 4.43938 3.14153C4.25184 3.32906 4.14648 3.58342 4.14648 3.84863V19.8486C4.14648 20.1138 4.25184 20.3682 4.43938 20.5557C4.62691 20.7433 4.88127 20.8486 5.14648 20.8486H6.14648V21.8486C6.14648 22.1138 6.25184 22.3682 6.43938 22.5557C6.62691 22.7433 6.88127 22.8486 7.14648 22.8486C7.4117 22.8486 7.66605 22.7433 7.85359 22.5557C8.04113 22.3682 8.14648 22.1138 8.14648 21.8486V20.8486H17.1465C17.9421 20.8486 18.7052 20.5326 19.2678 19.97C19.8304 19.4073 20.1465 18.6443 20.1465 17.8486V5.84863C20.1465 5.05298 19.8304 4.28992 19.2678 3.72731C18.7052 3.1647 17.9421 2.84863 17.1465 2.84863ZM14.1465 18.8486H6.14648V4.84863H14.1465V18.8486ZM18.1465 17.8486C18.1465 18.1138 18.0411 18.3682 17.8536 18.5557C17.6661 18.7433 17.4117 18.8486 17.1465 18.8486H16.1465V4.84863H17.1465C17.4117 4.84863 17.6661 4.95399 17.8536 5.14153C18.0411 5.32906 18.1465 5.58342 18.1465 5.84863V17.8486Z"
                            fill="#53B7E8"
                          />
                        </svg>
                      )}
                      {/* <span className={isHovered ? "activeColorBlue" : ""}>
                      My Profile
                    </span> */}
                      <span className="activeColorBlue">My Diary</span>
                    </Link>
                  ) : (
                    <Link
                      to="/mydiary"
                      className={isHovered3 ? "activeColorBlue" : ""}
                    >
                      {isHovered3 ? (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1465 2.84863H5.14648C4.88127 2.84863 4.62691 2.95399 4.43938 3.14153C4.25184 3.32906 4.14648 3.58342 4.14648 3.84863V19.8486C4.14648 20.1138 4.25184 20.3682 4.43938 20.5557C4.62691 20.7433 4.88127 20.8486 5.14648 20.8486H6.14648V21.8486C6.14648 22.1138 6.25184 22.3682 6.43938 22.5557C6.62691 22.7433 6.88127 22.8486 7.14648 22.8486C7.4117 22.8486 7.66605 22.7433 7.85359 22.5557C8.04113 22.3682 8.14648 22.1138 8.14648 21.8486V20.8486H17.1465C17.9421 20.8486 18.7052 20.5326 19.2678 19.97C19.8304 19.4073 20.1465 18.6443 20.1465 17.8486V5.84863C20.1465 5.05298 19.8304 4.28992 19.2678 3.72731C18.7052 3.1647 17.9421 2.84863 17.1465 2.84863ZM14.1465 18.8486H6.14648V4.84863H14.1465V18.8486ZM18.1465 17.8486C18.1465 18.1138 18.0411 18.3682 17.8536 18.5557C17.6661 18.7433 17.4117 18.8486 17.1465 18.8486H16.1465V4.84863H17.1465C17.4117 4.84863 17.6661 4.95399 17.8536 5.14153C18.0411 5.32906 18.1465 5.58342 18.1465 5.84863V17.8486Z"
                            fill="#53B7E8"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1465 2.84863H5.14648C4.88127 2.84863 4.62691 2.95399 4.43938 3.14153C4.25184 3.32906 4.14648 3.58342 4.14648 3.84863V19.8486C4.14648 20.1138 4.25184 20.3682 4.43938 20.5557C4.62691 20.7433 4.88127 20.8486 5.14648 20.8486H6.14648V21.8486C6.14648 22.1138 6.25184 22.3682 6.43938 22.5557C6.62691 22.7433 6.88127 22.8486 7.14648 22.8486C7.4117 22.8486 7.66605 22.7433 7.85359 22.5557C8.04113 22.3682 8.14648 22.1138 8.14648 21.8486V20.8486H17.1465C17.9421 20.8486 18.7052 20.5326 19.2678 19.97C19.8304 19.4073 20.1465 18.6443 20.1465 17.8486V5.84863C20.1465 5.05298 19.8304 4.28992 19.2678 3.72731C18.7052 3.1647 17.9421 2.84863 17.1465 2.84863ZM14.1465 18.8486H6.14648V4.84863H14.1465V18.8486ZM18.1465 17.8486C18.1465 18.1138 18.0411 18.3682 17.8536 18.5557C17.6661 18.7433 17.4117 18.8486 17.1465 18.8486H16.1465V4.84863H17.1465C17.4117 4.84863 17.6661 4.95399 17.8536 5.14153C18.0411 5.32906 18.1465 5.58342 18.1465 5.84863V17.8486Z"
                            fill="rgba(17, 17, 17, 0.5)"
                          />
                        </svg>
                      )}
                      <span className={isHovered3 ? "activeColorBlue" : ""}>
                        My Diary
                      </span>
                    </Link>
                  )}
                </Dropdown.Item>

                {permissions && permissions["View My Documents"] && (
                  <Dropdown.Item
                    href="#/action-4"
                    onMouseEnter={onMouseEnter4}
                    onMouseLeave={onMouseLeave4}
                  >
                    {currentRoute == "/personal" ? (
                      <Link
                        to="/personal"
                        className={
                          currentRoute == "/personal" ? "activeColorBlue" : ""
                        }
                      >
                        {isHovered4 ? (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2217 21.8486L14.4717 18.8486L15.6317 17.6886L17.2217 19.2786L20.8117 15.6886L21.9717 17.0986M13.0217 21.8486H5.22168C4.11168 21.8486 3.22168 20.9586 3.22168 19.8486V5.84863C3.22168 4.73863 4.11168 3.84863 5.22168 3.84863H19.2217C20.3317 3.84863 21.2217 4.73863 21.2217 5.84863V13.6486C20.6117 13.2986 19.9417 13.0486 19.2217 12.9286V5.84863H5.22168V19.8486H12.3017C12.4217 20.5686 12.6717 21.2386 13.0217 21.8486ZM12.2217 17.8486H7.22168V15.8486H12.2217M14.9017 13.8486H7.22168V11.8486H17.2217V12.9286C16.3717 13.0686 15.5917 13.3886 14.9017 13.8486ZM17.2217 9.84863H7.22168V7.84863H17.2217"
                              fill="#53B7E8"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2217 21.8486L14.4717 18.8486L15.6317 17.6886L17.2217 19.2786L20.8117 15.6886L21.9717 17.0986M13.0217 21.8486H5.22168C4.11168 21.8486 3.22168 20.9586 3.22168 19.8486V5.84863C3.22168 4.73863 4.11168 3.84863 5.22168 3.84863H19.2217C20.3317 3.84863 21.2217 4.73863 21.2217 5.84863V13.6486C20.6117 13.2986 19.9417 13.0486 19.2217 12.9286V5.84863H5.22168V19.8486H12.3017C12.4217 20.5686 12.6717 21.2386 13.0217 21.8486ZM12.2217 17.8486H7.22168V15.8486H12.2217M14.9017 13.8486H7.22168V11.8486H17.2217V12.9286C16.3717 13.0686 15.5917 13.3886 14.9017 13.8486ZM17.2217 9.84863H7.22168V7.84863H17.2217"
                              fill="#53B7E8"
                            />
                          </svg>
                        )}
                        {/* <span className={isHovered ? "activeColorBlue" : ""}>
                      My Profile
                    </span> */}
                        <span className="activeColorBlue">My Documents</span>
                      </Link>
                    ) : (
                      <Link
                        to="/personal"
                        className={isHovered4 ? "activeColorBlue" : ""}
                      >
                        {isHovered4 ? (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2217 21.8486L14.4717 18.8486L15.6317 17.6886L17.2217 19.2786L20.8117 15.6886L21.9717 17.0986M13.0217 21.8486H5.22168C4.11168 21.8486 3.22168 20.9586 3.22168 19.8486V5.84863C3.22168 4.73863 4.11168 3.84863 5.22168 3.84863H19.2217C20.3317 3.84863 21.2217 4.73863 21.2217 5.84863V13.6486C20.6117 13.2986 19.9417 13.0486 19.2217 12.9286V5.84863H5.22168V19.8486H12.3017C12.4217 20.5686 12.6717 21.2386 13.0217 21.8486ZM12.2217 17.8486H7.22168V15.8486H12.2217M14.9017 13.8486H7.22168V11.8486H17.2217V12.9286C16.3717 13.0686 15.5917 13.3886 14.9017 13.8486ZM17.2217 9.84863H7.22168V7.84863H17.2217"
                              fill="#53B7E8"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2217 21.8486L14.4717 18.8486L15.6317 17.6886L17.2217 19.2786L20.8117 15.6886L21.9717 17.0986M13.0217 21.8486H5.22168C4.11168 21.8486 3.22168 20.9586 3.22168 19.8486V5.84863C3.22168 4.73863 4.11168 3.84863 5.22168 3.84863H19.2217C20.3317 3.84863 21.2217 4.73863 21.2217 5.84863V13.6486C20.6117 13.2986 19.9417 13.0486 19.2217 12.9286V5.84863H5.22168V19.8486H12.3017C12.4217 20.5686 12.6717 21.2386 13.0217 21.8486ZM12.2217 17.8486H7.22168V15.8486H12.2217M14.9017 13.8486H7.22168V11.8486H17.2217V12.9286C16.3717 13.0686 15.5917 13.3886 14.9017 13.8486ZM17.2217 9.84863H7.22168V7.84863H17.2217"
                              fill="rgba(17, 17, 17, 0.5)"
                            />
                          </svg>
                        )}
                        <span className={isHovered4 ? "activeColorBlue" : ""}>
                          My Documents
                        </span>
                      </Link>
                    )}
                  </Dropdown.Item>
                )}

                <Dropdown.Item
                  href="#/action-4"
                  onMouseEnter={onMouseEnter5}
                  onMouseLeave={onMouseLeave5}
                >
                  {currentRoute == "/wallet/dashboard" ? (
                    <Link
                      to="/wallet/dashboard"
                      className={
                        currentRoute == "/wallet/dashboard"
                          ? "activeColorBlue"
                          : ""
                      }
                    >
                      {isHovered5 ? (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.2217 21.8486L14.4717 18.8486L15.6317 17.6886L17.2217 19.2786L20.8117 15.6886L21.9717 17.0986M13.0217 21.8486H5.22168C4.11168 21.8486 3.22168 20.9586 3.22168 19.8486V5.84863C3.22168 4.73863 4.11168 3.84863 5.22168 3.84863H19.2217C20.3317 3.84863 21.2217 4.73863 21.2217 5.84863V13.6486C20.6117 13.2986 19.9417 13.0486 19.2217 12.9286V5.84863H5.22168V19.8486H12.3017C12.4217 20.5686 12.6717 21.2386 13.0217 21.8486ZM12.2217 17.8486H7.22168V15.8486H12.2217M14.9017 13.8486H7.22168V11.8486H17.2217V12.9286C16.3717 13.0686 15.5917 13.3886 14.9017 13.8486ZM17.2217 9.84863H7.22168V7.84863H17.2217"
                            fill="#53B7E8"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.2217 21.8486L14.4717 18.8486L15.6317 17.6886L17.2217 19.2786L20.8117 15.6886L21.9717 17.0986M13.0217 21.8486H5.22168C4.11168 21.8486 3.22168 20.9586 3.22168 19.8486V5.84863C3.22168 4.73863 4.11168 3.84863 5.22168 3.84863H19.2217C20.3317 3.84863 21.2217 4.73863 21.2217 5.84863V13.6486C20.6117 13.2986 19.9417 13.0486 19.2217 12.9286V5.84863H5.22168V19.8486H12.3017C12.4217 20.5686 12.6717 21.2386 13.0217 21.8486ZM12.2217 17.8486H7.22168V15.8486H12.2217M14.9017 13.8486H7.22168V11.8486H17.2217V12.9286C16.3717 13.0686 15.5917 13.3886 14.9017 13.8486ZM17.2217 9.84863H7.22168V7.84863H17.2217"
                            fill="#53B7E8"
                          />
                        </svg>
                      )}
                      {/* <span className={isHovered ? "activeColorBlue" : ""}>
                      My Profile
                    </span> */}
                      <span className="activeColorBlue">My Wallet</span>
                    </Link>
                  ) : (
                    <Link
                      to="/wallet/dashboard"
                      className={isHovered5 ? "activeColorBlue" : ""}
                    >
                      {isHovered5 ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#53b7e8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-wallet-icon lucide-wallet"
                        >
                          <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
                          <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#11111180"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-wallet-icon lucide-wallet"
                        >
                          <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
                          <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
                        </svg>
                      )}
                      <span className={isHovered5 ? "activeColorBlue" : ""}>
                        My Wallet
                      </span>
                    </Link>
                  )}
                </Dropdown.Item>

                <Dropdown.Item>
                  <div
                    className="d-flex main-logout"
                    onClick={() => setLogoutModalShow(true)}
                  >
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.5 4.5082C13.5002 3.95592 13.0527 3.50803 12.5004 3.50781C11.9481 3.5076 11.5002 3.95514 11.5 4.50742L11.4968 12.5109C11.4966 13.0632 11.9442 13.511 12.4965 13.5113C13.0487 13.5115 13.4966 13.0639 13.4968 12.5117L13.5 4.5082Z"
                        fill="#cccccc"
                        fill-opacity="1"
                      />
                      <path
                        d="M4.5 13.4909C4.5 11.2818 5.39541 9.28186 6.84308 7.83415L8.2573 9.24837C7.17155 10.3341 6.5 11.8341 6.5 13.4909C6.5 16.8047 9.18629 19.4909 12.5 19.4909C15.8137 19.4909 18.5 16.8047 18.5 13.4909C18.5 11.8341 17.8284 10.3341 16.7426 9.2483L18.1568 7.83408C19.6046 9.2818 20.5 11.2818 20.5 13.4909C20.5 17.9092 16.9183 21.4909 12.5 21.4909C8.08172 21.4909 4.5 17.9092 4.5 13.4909Z"
                        fill="#cccccc"
                        fill-opacity="1"
                      />
                    </svg>
                    <span className="menu-name">Logout</span>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </header>
        ) : null}
      </div>

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={logoutModalShow}
        className="create-workflow-main modal-md"
        onHide={() => setLogoutModalShow(false)}
      >
        <Modal.Header>
          <Modal.Title>
            <label htmlFor="" className="create-role-text">
              User Logout
            </label>
          </Modal.Title>
          <img
            src={close}
            alt=""
            onClick={() => setLogoutModalShow(false)}
            className="cr-class"
          />
        </Modal.Header>
        <div className="hr-line-modal">
          <hr style={{ margin: "0" }} />
        </div>
        <Modal.Body className="text-center">
          Are you sure you want to Logout ?
        </Modal.Body>
        <div
          style={{ padding: "15px", display: "flex", justifyContent: "center" }}
        >
          <button
            className="modal-cancel-btn sm-btn-delete"
            onClick={() => setLogoutModalShow(false)}
          >
            Cancel
          </button>
          <button className="modal-create-btn sm-btn-delete" onClick={logout}>
            Yes
          </button>
        </div>
      </Modal>

      {/* Session Logout Modal */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={openSessionLogoutModal}
        className="create-workflow-main modal-md"
      >
        <Modal.Header>
          <Modal.Title>
            <label htmlFor="" className="create-role-text">
              Session expired !
            </label>
          </Modal.Title>
          {/* <img
            src={close}
            alt=''
            onClick={() => setLogoutModalShow(false)}
            className='cr-class'
          /> */}
        </Modal.Header>
        <div className="hr-line-modal">
          <hr style={{ margin: "0" }} />
        </div>
        <Modal.Body className="text-center">
          Please log in again to continue using the app.
        </Modal.Body>
        <div
          style={{ padding: "15px", display: "flex", justifyContent: "end" }}
        >
          <button className="modal-create-btn sm-btn-delete" onClick={logout}>
            Log in
          </button>
        </div>
      </Modal>
    </main>
  );
};

export default Header;
